import { render } from "./Index_contact_m.vue?vue&type=template&id=12e548e7&scoped=true"
import script from "./Index_contact_m.vue?vue&type=script&lang=js"
export * from "./Index_contact_m.vue?vue&type=script&lang=js"

import "./Index_contact_m.vue?vue&type=style&index=0&id=12e548e7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12e548e7"

export default script